import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslocoModule } from '@jsverse/transloco';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  standalone: true,
  selector: 'app-external-exit-dialog',
  template: `
    <h1 mat-dialog-title>{{ 'common.exit_dialog_title' | transloco }}</h1>
    <div mat-dialog-content>
      <p>{{ 'common.exit_dialog_text' | transloco }}</p>
    </div>
    <div mat-dialog-actions align="end">
      <button mat-button (click)="dialogRef.close(false)">
        {{ 'common.no' | transloco }}
      </button>
      <button mat-flat-button color="primary" (click)="dialogRef.close(true)">
        {{ 'common.yes' | transloco }}
      </button>
    </div>
  `,
  imports: [MatDialogModule, MatButtonModule, TranslocoModule]
})
export class ExternalExitDialogComponent {
  constructor(public dialogRef: MatDialogRef<ExternalExitDialogComponent>) {}
}
